import React from "react";
import clsx from "clsx";

const ServiceCard = ({
  icon: Icon,
  title,
  description,
  features = [],
  className,
}) => {
  return (
    <div
      className={clsx(
        "group rounded-2xl border border-slate-200 bg-white p-8 transition-all hover:-translate-y-1 hover:shadow-xl",
        className
      )}
    >
      {/* Icon */}
      {Icon && (
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-100 text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-colors">
          <Icon size={24} />
        </div>
      )}

      {/* Title */}
      <h3 className="mt-6 text-xl font-semibold text-slate-900">
        {title}
      </h3>

      {/* Description */}
      <p className="mt-3 text-sm text-slate-600 leading-relaxed">
        {description}
      </p>

      {/* Features */}
      {features.length > 0 && (
        <ul className="mt-6 space-y-2 text-sm text-slate-600">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start gap-2">
              <span className="mt-1 h-1.5 w-1.5 rounded-full bg-blue-600" />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ServiceCard;
